<div class="pr-sub-panel-header" [ngClass]="clazz">{{ title }}</div>
<div class="pr-sub-panel-body" [ngClass]="class">
  <ng-content></ng-content>
</div>
